import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import classNames from 'classnames';
import _compact from 'lodash/compact';
import _entries from 'lodash/entries';
import _get from 'lodash/get';
import { LOCALE_MESSAGES } from './LocaleContext';
import { globalZIndex } from './zIndexContext';
import renderEmpty from './renderEmpty';
export var getModifyName = function getModifyName(value) {
  var modifyName;

  switch (value) {
    case 'default':
      modifyName = '';
      break;

    case 'large':
      modifyName = 'lg';
      break;

    case 'middle':
    case 'medium':
      modifyName = 'md';
      break;

    case 'small':
      modifyName = 'sm';
      break;

    case 'xSmall':
      modifyName = 'xs';
      break;

    default:
      modifyName = value;
      break;
  }

  return modifyName;
};
export var getModifyCls = function getModifyCls(modifiers, elementName) {
  return _entries(modifiers).reduce(function (acc, cur) {
    var _cur = _slicedToArray(cur, 2),
        key = _cur[0],
        value = _cur[1];

    var modifyName = key;

    if (typeof value === 'string') {
      modifyName = getModifyName(value);

      if (modifyName) {
        acc["".concat(elementName, "-").concat(modifyName)] = !!value;
      }
    } else {
      acc["".concat(elementName, "-").concat(modifyName)] = !!value;
    }

    return acc;
  }, {});
};
export var getPrefixCls = function getPrefixCls() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rock';
  return function (suffix, prefixCls) {
    if (!prefixCls) {
      prefixCls = suffix ? "".concat(prefix, "-").concat(suffix) : prefix;
    }

    return prefixCls;
  };
};
export var getPrettyCls = function getPrettyCls() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rock';
  return function (suffix, prefixCls, outerClassName) {
    prefixCls = getPrefixCls(prefix)(suffix, prefixCls);
    return function (modifiers, element, innerClassName) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      if (typeof modifiers === 'string') {
        innerClassName = element;
        element = modifiers;
        modifiers = {};
      }

      var elementName = _compact([prefixCls, element]).join('-');

      var modifyNames = getModifyCls(modifiers, elementName);
      return classNames(options.stripElementName ? null : elementName, modifyNames, outerClassName, innerClassName);
    };
  };
};
export var getGlobalZIndex = function getGlobalZIndex() {
  return globalZIndex.value;
};
var ConfigContext = /*#__PURE__*/React.createContext({
  autoSize: true,
  iconPrefix: 'icon-b',
  mousePositionDisabled: false,
  getLocale: function getLocale(locale, componentName) {
    return _get(LOCALE_MESSAGES, [locale, componentName]);
  },
  getPrefixCls: getPrefixCls(),
  getPrettyCls: getPrettyCls(),
  getGlobalZIndex: getGlobalZIndex,
  renderEmpty: renderEmpty
});
export var ConfigConsumer = ConfigContext.Consumer;
export var ConfigProvider = ConfigContext.Provider;
export default ConfigContext;